import { defineComponent as n, openBlock as t, createBlock as h, unref as r, mergeProps as l, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const m = /* @__PURE__ */ n({
  name: "IconCpu",
  __name: "IconCpu",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(v) {
    const o = v;
    return (u, e) => (t(), h(r(d), l(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M7.25 9.5A2.25 2.25 0 0 1 9.5 7.25h5a2.25 2.25 0 0 1 2.25 2.25v5a2.25 2.25 0 0 1-2.25 2.25h-5a2.25 2.25 0 0 1-2.25-2.25v-5M9.5 8.75A.75.75 0 0 0 8.75 9.5v5a.75.75 0 0 0 .75.75h5a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75h-5",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M9 2.25A.75.75 0 0 1 9.75 3v1.25h1.5V3a.75.75 0 0 1 1.5 0v1.25h1.5V3a.75.75 0 0 1 1.5 0v1.25h1.75a2.25 2.25 0 0 1 2.25 2.25v1.75H21a.75.75 0 0 1 0 1.5h-1.25v1.5H21a.75.75 0 0 1 0 1.5h-1.25v1.5H21a.75.75 0 0 1 0 1.5h-1.25v1.75a2.25 2.25 0 0 1-2.25 2.25h-1.75V21a.75.75 0 0 1-1.5 0v-1.25h-1.5V21a.75.75 0 0 1-1.5 0v-1.25h-1.5V21a.75.75 0 0 1-1.5 0v-1.25H6.5a2.25 2.25 0 0 1-2.25-2.25v-1.75H3a.75.75 0 0 1 0-1.5h1.25v-1.5H3a.75.75 0 0 1 0-1.5h1.25v-1.5H3a.75.75 0 0 1 0-1.5h1.25V6.5A2.25 2.25 0 0 1 6.5 4.25h1.75V3A.75.75 0 0 1 9 2.25m-2.5 3.5A.75.75 0 0 0 5.75 6.5v11a.75.75 0 0 0 .75.75h11a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-11",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  m as default
};
